var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClientManagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 17.2499C0.751544 14.9833 1.89011 12.8686 3.78149 11.6195C5.67287 10.3704 8.06476 10.1534 10.15 11.0419",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 9C9.77817 9 11.625 7.15317 11.625 4.875C11.625 2.59683 9.77817 0.75 7.5 0.75C5.22183 0.75 3.375 2.59683 3.375 4.875C3.375 7.15317 5.22183 9 7.5 9Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 18C18.0784 18 18.75 17.3284 18.75 16.5C18.75 15.6716 18.0784 15 17.25 15C16.4216 15 15.75 15.6716 15.75 16.5C15.75 17.3284 16.4216 18 17.25 18Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.524 10.7002L18.966 12.1532C19.1173 12.6536 19.6305 12.9512 20.14 12.8342L21.612 12.4932C22.1847 12.3641 22.7747 12.6231 23.0672 13.1321C23.3598 13.6411 23.2867 14.2812 22.887 14.7112L21.856 15.8222C21.499 16.206 21.499 16.8003 21.856 17.1842L22.887 18.2952C23.2867 18.7251 23.3598 19.3653 23.0672 19.8742C22.7747 20.3832 22.1847 20.6422 21.612 20.5132L20.14 20.1722C19.6305 20.0551 19.1173 20.3528 18.966 20.8532L18.524 22.3002C18.3553 22.8629 17.8374 23.2483 17.25 23.2483C16.6625 23.2483 16.1447 22.8629 15.976 22.3002L15.534 20.8472C15.3826 20.3468 14.8695 20.0491 14.36 20.1662L12.888 20.5072C12.3153 20.6362 11.7253 20.3772 11.4327 19.8682C11.1402 19.3593 11.2132 18.7191 11.613 18.2892L12.644 17.1782C13.0009 16.7943 13.0009 16.2 12.644 15.8162L11.613 14.7052C11.2132 14.2752 11.1402 13.6351 11.4327 13.1261C11.7253 12.6171 12.3153 12.3581 12.888 12.4872L14.36 12.8282C14.8695 12.9452 15.3826 12.6476 15.534 12.1472L15.976 10.6942C16.146 10.1318 16.6648 9.74764 17.2522 9.74903C17.8397 9.75041 18.3566 10.137 18.524 10.7002V10.7002Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientManagement);
export default __webpack_public_path__ + "static/media/client-management.b42dce6468c7bba4e4e0e930fd6da1b3.svg";
export { ForwardRef as ReactComponent };